export function getBuildVersion(): string {
  const metaEnv = typeof import.meta !== 'undefined' ? import.meta.env : undefined;
  const value = metaEnv?.VITE_BUILD_VERSION;

  if (typeof value === 'string' && value.trim()) {
    return value;
  }

  return 'dev';
}

interface ParsedBuildVersion {
  marketingVersion: string;
  buildNumber: string | null;
}

export function parseBuildVersion(raw: string): ParsedBuildVersion {
  const base = (raw || '').trim() || 'dev';
  const plusIndex = base.indexOf('+');
  const marketingVersion = plusIndex > -1 ? base.slice(0, plusIndex) || 'dev' : base;
  const plusPayload = (plusIndex > -1 ? base.slice(plusIndex + 1) : '').trim();
  const buildNumber = plusPayload.match(/^[0-9A-Za-z._-]+$/)?.[0] ?? null;
  return {
    marketingVersion,
    buildNumber,
  };
}

export function formatBuildVersion(raw: string): string {
  const parsed = parseBuildVersion(raw);
  if (parsed.buildNumber) {
    return `${parsed.marketingVersion}.${parsed.buildNumber}`;
  }
  return parsed.marketingVersion;
}

export function formatNativeBuildVersion(
  marketingVersionRaw: string,
  buildNumberRaw?: string | null,
): string {
  const marketingVersion = (marketingVersionRaw || '').trim() || 'dev';
  const buildNumber = (buildNumberRaw || '').trim();
  if (buildNumber) {
    return `${marketingVersion}.${buildNumber}`;
  }
  return marketingVersion;
}

export const appMetadata = {
  buildVersion: getBuildVersion(),
};
